<template>
    <div>
        <ul>
            <li>
                <div class="toolListLink" style="background-color: rgb(206, 232, 255);">
                        工具栏
                </div>
            </li>
            <li v-for="item in toolList" :key="item">
                <a :href="item.src">
                    <div class="toolListLink">
                        {{item.name}}
                        <div class="toolListIntro">
                        {{item.intro}}
                    </div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'ToolList',
    data(){
        return{
            toolList:[
                {src:"./todolist/index.html",name:'代办列表',intro:'一个可以存储在本地浏览器的备忘录'},
                {src:"https://my.wulvxinchen.cn/tools/",name:'工具网站导航',intro:'一个在线的搜集了许多有趣网站的导航'},
                {src:"https://my.wulvxinchen.cn/genshincard/",name:'原神名片生成',intro:'可以在线生成一张属于自己的原神名片'},
            ],
        }
    },
}
</script>

<style>
    .toolListLink{
        background-color: rgb(206, 232, 255);
    
        border-radius: 0.5em;
        width: 250px;
        height: 40px;
        margin-bottom: 1.45em;
        padding-top:0.7em;

        color: #000000;
        font-size: 1.2em;
        font-weight: 600;
    }
    .toolListLink:hover{
        background-color: rgb(236, 246, 255);
        height: 38px;
        border: #000000 1px solid;
    }
    .toolListLink:hover .toolListIntro{
        display: block;
    }

    .toolListIntro{
        display: none;

        position: fixed;
        
        width: 10em;
        padding: 0.4em;
        margin: 5px 0px 0px 130px;
        z-index: 1;
        background-color: rgb(206, 232, 255);
        border-radius: 0.5em;
        border: #000000 1px solid;
        font-size: 0.5em;
        font-weight: 500;
    }
</style>